import { Table } from 'antd';
import styled from 'styled-components';
import { ISurveyItem } from './TableContent.types';
import { LabelRegularBoldM, LabelRegularM } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';

export const OrganizationName = styled(LabelRegularBoldM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]}
  `}
`;

export const TableData = styled(LabelRegularM)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]}
  `}
`;

export const EndDate = styled(TableData)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]}
  `}
`;

export const Header = styled(LabelRegularBoldM)`
  letter-spacing: 0.08em;
  text-transform: uppercase;
  ${({ theme }: IThemeProvider) => `
     color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const StatusTitle = styled.div`
  ${({ theme }: IThemeProvider) => `
     margin-right: ${theme.layout.spacing.mikro};
  `}
`;

export const StyledTable: typeof Table = styled(Table)<ISurveyItem>`
  margin-bottom: 32px;

  .ant-table {
    background: transparent;

    table {
      ${({ theme }: IThemeProvider) => `
       border-spacing: 0 ${theme.layout.spacing.mili};
     `}

      .ant-table-thead {
        th {
          background: transparent;
          padding: 8px 16px;
          ${({ theme }: IThemeProvider) => `
            border-top: 1px solid ${theme.colors.neutral.primary[30]};
        `}
          &:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
            content: none;
          }
        }

        .ant-table-column-title {
          flex: unset;
          ${({ theme }: IThemeProvider) => `
          margin-right: ${theme.layout.spacing.centy};
        `}
        }
        .ant-table-filter-column,
        .ant-table-column-sorters {
          justify-content: flex-start;

          .ant-table-column-sorter-inner .active {
            color: ${({ theme }: IThemeProvider) => theme.colors.secondary[100]};
          }
        }
      }

      .ant-table-tbody {
        tr {
          cursor: pointer;
          ${({ theme }: IThemeProvider) => `
          border-radius: ${theme.layout.spacing.mikro};
          box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
        `}

          .ant-table-cell {
            height: 48px;
            ${({ theme }: IThemeProvider) => `
            background: ${theme.colors.neutral.primary[0]};
            padding: 0 ${theme.layout.spacing.centy};
          `}
            span.organization-name, span.survey-name {
              display: -webkit-box !important;
              -webkit-box-orient: vertical;
              text-overflow: ellipsis;
              overflow: hidden;
              -webkit-line-clamp: 2;
            }
          }

          td:first-child {
            ${({ theme }: IThemeProvider) => `
          border-top-left-radius: ${theme.layout.spacing.mikro};
          border-bottom-left-radius: ${theme.layout.spacing.mikro};
        `}
          }

          td:last-child {
            ${({ theme }: IThemeProvider) => `
          border-top-right-radius: ${theme.layout.spacing.mikro};
          border-bottom-right-radius: ${theme.layout.spacing.mikro};
        `}
          }
        }
      }
    }
  }
`;
